import dayjs from "dayjs";

export function productDurationToMinutes(duration: string) {
  return dayjs(duration, "HH:mm").diff(dayjs().startOf("day"), "minutes");
}

export function minutesToProductDuration(minutes: number) {
  return dayjs().startOf("day").set("minutes", minutes).format("HH:mm");
}
